import { useEffect } from 'react';

interface UseNavigationBlockerProps {
  isDirty: boolean;
  onConfirmNavigation?: () => void;
}

export function useNavigationBlocker({ 
  isDirty, 
  onConfirmNavigation 
}: UseNavigationBlockerProps) {
  
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    const handlePopState = (event: PopStateEvent) => {
      if (isDirty) {
        const confirmNavigation = window.confirm(
          'У вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?'
        );
        
        if (!confirmNavigation) {
          window.history.pushState(null, '', window.location.href);
        } else if (onConfirmNavigation) {
          onConfirmNavigation();
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isDirty, onConfirmNavigation]);
}
